/**
 * "Alguns registros ainda não chegaram" (the owner, 22/10/2026; docs/refactor/52): while the desktop keeps reports the
 * API could not take, a quiet bar at the foot of the menu says how many, that nothing of the person's work stopped,
 * and offers "Enviar agora". It goes away by itself once everything has arrived. Desktop only, like the reports.
 */

import { useEffect, useState } from 'react'
import { CloudOff, Loader2, RefreshCw } from 'lucide-react'
import { useI18n } from '../lib/i18n'
import type { AgentReporter } from '../lib/agentTelemetry'

export function OutboxNotice({ reporter }: { reporter: AgentReporter | null }) {
  const { t } = useI18n()
  const [count, setCount] = useState(() => reporter?.outbox().count ?? 0)
  const [busy, setBusy] = useState(false)
  const [stillDown, setStillDown] = useState(false)

  useEffect(() => {
    if (!reporter) return
    setCount(reporter.outbox().count)
    return reporter.subscribe(() => setCount(reporter.outbox().count))
  }, [reporter])

  if (!reporter || count === 0) return null

  const sync = async () => {
    setBusy(true)
    setStillDown(false)
    const { left } = await reporter.retry().catch(() => ({ left: count }))
    setBusy(false)
    setStillDown(left > 0)
  }

  return (
    <div className="notice small stack stack--tight outbox-notice" role="status">
      <span className="row row--tight">
        <CloudOff size={14} aria-hidden /> {t('outbox.waiting', { count })}
      </span>
      <span className="tiny muted">{stillDown ? t('outbox.stillDown') : t('outbox.hint')}</span>
      <button type="button" className="btn btn--sm" onClick={() => void sync()} disabled={busy}>
        {busy ? <Loader2 size={13} className="spin" aria-hidden /> : <RefreshCw size={13} aria-hidden />} {t('outbox.sync')}
      </button>
    </div>
  )
}
